import React from "react";
import { useSelector } from "react-redux";

import { getCurrentDispensary } from "redux/selectors/dispensary";

import PrimaryAddress from "components/Dispensary/AboutDispensary/PrimaryAddress";
import DispensaryBreadcrumbs from "components/Dispensary/DispensaryBreadcrumbs";
import CallDispensary from "components/Dispensary/DispensaryHeader/CallDispensary";

const UnclaimedHeader = () => {
  const { name } = useSelector(getCurrentDispensary);

  return (
    <>
      <DispensaryBreadcrumbs />
      <div className="bg-white pb-xl">
        <div className="container">
          <h1 className="heading--l font-headers font-bold mb-lg lg:my-xs">
            {name}
          </h1>
          <PrimaryAddress />
          <CallDispensary />
        </div>
      </div>
    </>
  );
};

export default UnclaimedHeader;
